import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form, Message, Modal } from 'semantic-ui-react';
import { API, showError, showSuccess } from '../../../helpers';

const MAX_FILE_SIZE = 10 * 1024 * 1024;

export const validateAlibabaBillingFile = (file) => {
  if (!file) return '请选择账单文件';
  const fileName = file.name.toLowerCase();
  if (!fileName.endsWith('.xlsx') && !fileName.endsWith('.csv')) return '只支持 .xlsx 或 .csv 文件';
  if (file.size > MAX_FILE_SIZE) return '文件不能超过 10 MiB';
  return '';
};

export const uploadAlibabaBillingFile = (subject, file) => {
  const formData = new FormData();
  formData.append('subject', subject);
  formData.append('file', file);
  return API.post('/api/admin/channel-billing/import/alibaba', formData);
};

const AlibabaBillingImportModal = ({ open, onClose, onImported }) => {
  const { t } = useTranslation();
  const [subject, setSubject] = useState('qingbo');
  const [file, setFile] = useState(null);
  const [importing, setImporting] = useState(false);

  useEffect(() => {
    if (!open) return;
    setSubject('qingbo');
    setFile(null);
  }, [open]);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files?.[0] || null;
    if (!selectedFile) {
      setFile(null);
      return;
    }
    const validationError = validateAlibabaBillingFile(selectedFile);
    if (validationError) {
      showError(validationError);
      event.target.value = '';
      setFile(null);
      return;
    }
    setFile(selectedFile);
  };

  const handleImport = async () => {
    if (!file) {
      showError(t('channel_billing.alibaba.select_file', '请选择账单文件'));
      return;
    }

    setImporting(true);
    try {
      const response = await uploadAlibabaBillingFile(subject, file);
      if (!response) return;
      if (!response.data.success) {
        showError(response.data.message);
        return;
      }
      const { month, records } = response.data.data;
      showSuccess(`已导入 ${month}，共 ${records} 条日账单`);
      onImported();
      onClose();
    } catch (error) {
      showError(
        error.response?.data?.message ||
          t('channel_billing.alibaba.import_failed', '导入阿里账单失败')
      );
    } finally {
      setImporting(false);
    }
  };

  return (
    <Modal open={open} onClose={importing ? undefined : onClose} size='small'>
      <Modal.Header>导入阿里账单</Modal.Header>
      <Modal.Content>
        <Message info>
          选择主体后，系统只读取账单中的对应“阿里-清博主体”或
          “阿里-元娲主体”工作表。重复日期将覆盖原数据。
        </Message>
        <Form>
          <Form.Field required>
            <label htmlFor='alibaba-billing-subject'>主体</label>
            <select
              id='alibaba-billing-subject'
              value={subject}
              onChange={(event) => setSubject(event.target.value)}
            >
              <option value='qingbo'>清博主体</option>
              <option value='yuanwa'>元娲主体</option>
            </select>
          </Form.Field>
          <Form.Field required>
            <label htmlFor='alibaba-billing-file'>账单文件</label>
            <input
              id='alibaba-billing-file'
              type='file'
              accept='.xlsx,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv'
              onChange={handleFileChange}
            />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button disabled={importing} onClick={onClose}>
          取消
        </Button>
        <Button primary loading={importing} onClick={handleImport}>
          导入
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default AlibabaBillingImportModal;
